/**
 * The web's ask before the browser's own prompt (notify/permission.ts): a
 * glass bar under the title bar, shown only once a notification could not be
 * delivered for want of the permission, never on load.
 */
import { useState } from 'react';
import { useT } from '../i18n';
import { Btn, Icon } from '../ui/kit';
import { toast } from '../ui/overlay';
import { askBrowser, askLater, useNotifyAsk } from './permission';

export function NotifyAskBar() {
  const { t } = useT();
  const open = useNotifyAsk((s) => s.open);
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const allow = async () => {
    setBusy(true);
    const r = await askBrowser();
    setBusy(false);
    if (r === 'denied') toast(t('ns.set.notifBlocked'), { tone: 'warn', icon: 'bell-off' });
  };
  return (
    <div className="ns-alertbar nx-glass strong" role="status">
      <Icon name="bell" />
      <div className="ns-alertbar-t">
        <b>{t('nt.ask.title')}</b>
        <span className="ns-muted">{t('nt.ask.body')}</span>
      </div>
      <div className="ns-alertbar-acts">
        <Btn kind="ghost" size="sm" onClick={askLater}>
          {t('nt.ask.later')}
        </Btn>
        <Btn kind="primary" size="sm" busy={busy} onClick={() => void allow()}>
          {t('nt.ask.allow')}
        </Btn>
      </div>
    </div>
  );
}
